import { INVOICE_STATUS_LABEL, INVOICE_STATUS_TONE } from '../../Enums/stripe-status.enum';
import {
  CreditNoteResponse,
  InvoiceDetailResponse,
  InvoiceLineResponse,
  InvoicePaymentResponse,
} from '../../Interfaces/api/backoffice/billing-document.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class InvoiceDetail {
  id = '';
  stripe_invoice_id: string | null = null;
  stripe_status = '';
  display_status: string | null = null;
  plan_name: string | null = null;
  currency: string | null = null;
  subtotal: number | null = null;
  tax: number | null = null;
  total: number | null = null;
  period_start: string | null = null;
  period_end: string | null = null;
  issued_at: string | null = null;
  paid_at: string | null = null;
  seat_quantity: number | null = null;
  device_quantity: number | null = null;
  attempt_count = 0;
  collection_method: string | null = null;
  due_at: string | null = null;
  hosted_invoice_url: string | null = null;
  invoice_pdf_url: string | null = null;
  lines: InvoiceLineResponse[] = [];
  payments: InvoicePaymentResponse[] = [];
  credit_notes: CreditNoteResponse[] = [];
  creditable_remainder = 0;

  constructor(data: Partial<InvoiceDetailResponse> = {}) {
    Object.assign(this, data);
  }

  get statusLabelKey(): string {
    return INVOICE_STATUS_LABEL[this.stripe_status] ?? this.stripe_status;
  }

  get statusTone(): StatusTone {
    return INVOICE_STATUS_TONE[this.stripe_status] ?? 'neutral';
  }

  get hasDocument(): boolean {
    return Boolean(this.invoice_pdf_url || this.hosted_invoice_url);
  }

  get isSendable(): boolean {
    return this.stripe_status === 'open' || this.stripe_status === 'draft';
  }

  get isUncollectible(): boolean {
    return this.stripe_status === 'open';
  }

  get isCreditable(): boolean {
    return (
      this.creditable_remainder > 0 &&
      ['open', 'paid', 'uncollectible'].includes(this.stripe_status)
    );
  }

  get hasIncompleteSnapshot(): boolean {
    return this.seat_quantity === null && this.device_quantity === null && this.lines.length === 0;
  }
}
